import {
	BusinessClient,
	BaseClient,
	ClientType,
	PersonClient,
} from '@models/clients';
import {
	Form,
	FormField,
	FormSubSection,
	ClientIntakeFormType,
	FormValue,
	FormFileMetadata,
	UPLOADED_FILE_STATUS,
} from '@models/client-intake';
import {
	FieldViewModel,
	SubSectionViewModel,
} from '@domain/intake-form-client-portal';

// Type Guards
export function isFormField(
	item: FormField | FormSubSection,
): item is FormField {
	return 'type' in item;
}

export function isFormSubSection(
	item: FormField | FormSubSection,
): item is FormSubSection {
	return !('type' in item) && 'fields' in item;
}

export function isFieldViewModel(
	item: FieldViewModel | SubSectionViewModel,
): item is FieldViewModel {
	return 'field' in item;
}

export function isSubSectionViewModel(
	item: FieldViewModel | SubSectionViewModel,
): item is SubSectionViewModel {
	return 'subSection' in item;
}

export function isBusinessClient(client: BaseClient): client is BusinessClient {
	return (
		client.type === ClientType.CORPORATION || client.type === ClientType.BUILDER
	);
}

export function isPersonClient(client: BaseClient): client is PersonClient {
	return client.type === ClientType.PERSON;
}

export function isTimestamp(value: unknown): value is { toDate(): Date } {
	return (
		typeof value === 'object' &&
		value !== null &&
		'toDate' in value &&
		typeof (value as { toDate: unknown }).toDate === 'function'
	);
}

export function isFormFileMetadata(obj: unknown): obj is FormFileMetadata {
	return (
		typeof obj === 'object' &&
		obj !== null &&
		'fileName' in obj &&
		typeof (obj as FormFileMetadata).fileName === 'string' &&
		'id' in obj &&
		typeof (obj as FormFileMetadata).id === 'string' &&
		'path' in obj &&
		typeof (obj as FormFileMetadata).path === 'string' &&
		'fullPath' in obj &&
		typeof (obj as FormFileMetadata).fullPath === 'string' &&
		'size' in obj &&
		typeof (obj as FormFileMetadata).size === 'number' &&
		'type' in obj &&
		typeof (obj as FormFileMetadata).type === 'string' &&
		'status' in obj &&
		Object.values(UPLOADED_FILE_STATUS).includes(
			(obj as FormFileMetadata).status,
		) &&
		(!('firebaseStorageUrl' in obj) ||
			(obj as FormFileMetadata).firebaseStorageUrl === null ||
			typeof (obj as FormFileMetadata).firebaseStorageUrl === 'string') &&
		(!('fileData' in obj) ||
			(obj as FormFileMetadata).fileData === null ||
			(obj as FormFileMetadata).fileData instanceof File)
	);
}

export function convertTimestampValue(value: FormValue): FormValue {
	if (isTimestamp(value)) {
		return value.toDate();
	}
	return value;
}

//TODO: This might get removed when we update to generating the forms with the engine
export function sortForms(forms: Form[]): Form[] {
	return [...forms].sort((a, b) => {
		if (a.formType === ClientIntakeFormType.GENERAL) return 1;
		if (b.formType === ClientIntakeFormType.GENERAL) return -1;

		return a.name.localeCompare(b.name);
	});
}
